export const hasReachedQtyMinLimit = (qty: number, min: number): boolean => qty <= min;
export const hasReachedQtyMaxLimit = (qty: number, max: number): boolean => qty >= max;
export const isQtyOnlyOne = (min: number, max: number): boolean => min === max;
